import styled, { css, keyframes } from 'styled-components';

const revealLoading = keyframes`
    from {
        opacity: 0;
        pointer-events: none;
    }

    to {
        opacity: 1;
        pointer-events: auto;
    }
`;

interface StencilRouteTransitionLoadingLayoutProps {
    active: boolean;
    backgroundColor: string;
    delayMs: number;
    leftOffset: string;
    topOffset: string;
}

export const StencilRouteTransitionLoadingLayout = styled.div.withConfig({
    shouldForwardProp: (prop) => !['active', 'backgroundColor', 'delayMs', 'leftOffset', 'topOffset'].includes(prop),
})<StencilRouteTransitionLoadingLayoutProps>`
    position: fixed;
    inset: ${({ topOffset, leftOffset }) => `${topOffset} 0 0 ${leftOffset}`};
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    background: ${({ backgroundColor }) => backgroundColor};
    opacity: 0;
    will-change: opacity;

    ${({ active, delayMs }) =>
        active &&
        css`
            animation: ${revealLoading} 1ms linear ${delayMs}ms forwards;
        `}
`;
